<!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->

<!-- top -->
<template>
  <div>
    <v-container
      style="width: 100%"
      id="recent-container"
      class="px-0"
      v-if="lst_stats.length > 0"
    >
      <h4>Team K9</h4>
      <!-- :items="[
                'Print',
                'Print by Week',
                'Print by Month',
                'Download CSV',
                'Pie: Contact %',
                'Pie: Stop Type %',
                'Line: Count by Weeks',
              ]" -->
      <v-card class="mb-3">
        <v-card-text>
          <!-- report button -->
          <!-- @click="go_report" -->
          <!-- to="/report" -->
          <div class="d-flex flex-row justify-start align-start pt-0">
            <div style="width: 165px">
              <!-- add this back when doing tsep forms -->
              <!-- 'TSEP Form', -->
              <!-- <v-select
                attach
                class=""
                v-model="report_type"
                :items="['Print', 'Team Sum', 'Download CSV']"
                :rules="[(v) => !!v || 'Item is required']"
                label="Name/Type"
                required
              ></v-select> -->
              <v-select
                attach
                class=""
                v-model="report_type"
                :items="['Print', 'Team Sum', 'Download CSV']"
                :rules="[(v) => !!v || 'Item is required']"
                label="Name/Type"
                required
              ></v-select>
            </div>
            <div class="">
              <v-btn
                @click="go_report"
                color="cmpbk"
                class="white--text px-1 ml-4"
                style="font-size: xx-small; position: relative; top: 13px"
                >Execute Report</v-btn
              >
            </div>
            <v-spacer></v-spacer>
            <div class="">
              <div
                style="
                  line-height: 1;
                  font-size: 1rem;
                  font-weight: 800;
                  position: relative;
                  top: 23px;
                  margin-left: 5px;
                "
              >
                <span class="showcountlbl">Count:</span>
                <span class="showcountlblsmll">Cnt:</span>
                {{ lst_search_resultsk9.length }}
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-card
        style="width: 100%"
        :id="'srch' + stat.rpd_stat_k9Id"
        v-for="stat in lst_stats"
        :key="stat.id"
        class="mx-auto mb-2 recent-card"
      >
        <v-card-text>
          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Team:</div>
              <p class="mb-0 ml-2">
                {{ stat.team }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Stat Date:</div>
              <p class="mb-0 ml-2">
                {{ stat.stat_date }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Last modified:</div>
              <p class="mb-0 ml-2">
                {{ stat.s_date | shortDate }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Edited:</div>
              <p class="mb-0 ml-2">
                {{ stat.s_user }}
              </p>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Created:</div>
              <p class="mb-0 ml-2">
                {{ stat.s_created }}
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Area:</div>
              <p class="mb-0 ml-2">
                {{ stat.area }}
              </p>
            </v-col>
          </v-row>
        </v-card-text>

        <v-container class="checkbox-chips pt-0 mt-2 ml-2">
          <v-row v-if="is_admin == false">
            <v-col cols="12" class="d-flex justify-space-around">
              <v-btn
                v-on:click="view(stat)"
                color="cmpbk"
                class="white--text"
                style="font-size: smaller"
                >View</v-btn
              >
            </v-col>
          </v-row>
          <v-row v-if="is_admin">
            <v-col cols="12" class="d-flex justify-space-around">
              <v-btn
                v-on:click="edit(stat)"
                color="cmpbk"
                class="white--text"
                style="font-size: smaller"
                >Edit</v-btn
              >
              <v-btn
                v-on:click="delete_ask(stat)"
                color="cmpbk"
                class="white--text"
                style="font-size: smaller"
                >Delete</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <!-- ********************
       does NOt equal deeds is not right but it only runs this way******  -->
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
/* 0 media q */
@media (min-width: 0px) {
  .hide-if-small {
    display: none !important;
  }
  .hide-if-large {
    display: flex;
  }
  .cnt_disp span {
    color: rgb(9, 9, 243);
  }
  .results-card {
    max-width: 344px;
  }

  .accident {
    font-size: smaller;
  }

  .showcountlblsmll {
    display: inline;
  }
  .showcountlbl {
    display: none;
  }
  /*   .accident .v-application--is-ltr::v-deep .v-chip .v-avatar--left {
    margin-right: 0 !important;
  } */
}

/* 768 media q */
@media (min-width: 768px) {
  .hide-if-small {
    display: flex !important;
  }
  .hide-if-large {
    display: none !important;
  }
  .results-card {
    max-width: 90%;
  }
  .showcountlblsmll {
    display: none;
  }
  .showcountlbl {
    display: inline;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
const report = () => import("./report.vue");

export default {
  name: "searchResultsk9",
  mixins: [bus_common],
  props: ["lst_search_resultsk9", "update_search_results_k9", "sterm"],
  components: { report },
  data() {
    return {
      stat_data_map_view: {},
      update_map: null,
      map_view_dialog_visible: false,
      map_dialog_visible: false,
      report_type: "Print",
      lst_stats: [],
      group_size: 6,
      total_loaded: 0,
    };
  },
  watch: {
    lst_search_resultsk9: {
      deep: true,
      handler() {
        console.log(" lst_search_resultsk9 handler");
        this.show_loader(true);
        this.lst_stats = this.mno(this.lst_search_resultsk9);
        this.lst_stats.forEach((stat) => {
          stat.s_date = this.$moment(stat.s_date).format("MM/DD/YYYY");
          stat.stat_date = this.$moment(stat.stat_date).format("MM/DD/YYYY");
          stat.s_CreateDate = this.$moment(stat.s_CreateDate).format(
            "MM/DD/YYYY"
          );
        });

        this.show_loader(false);
        //this.$moment(value, 'YYYY-MM-DD', true);
      },
      immediate: true,
    },
  },
  computed: {
    is_admin: function () {
      if (this.$store.state.user.roles.indexOf("stat-admin") > -1) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    view(stat) {
      this.$emit("viewk9", stat, document.documentElement.scrollTop);
    },
    delete_ask(stat) {
      var self = this;
      this.swall_diag(
        "Confirm Delete",
        "You are deleting an item created by '" + stat.s_user + "'. Continue?",
        "question",
        function () {
          self.delete_now(stat);
        },
        null,
        null,
        function () {}
      );
    },
    delete_now(stat) {
      this.$emit("delete_nowk9", stat);
      var index = this.lst_stats.findIndex(
        (item) => item.stat_dataId === stat.stat_dataId
      );
      this.lst_stats.splice(index, 1);
    },

    remove_result(stat) {
      //this.mrbreakpoint("remove");
      var index = this.lst_stats.findIndex(
        (item) => item.rpd_stat_k9Id === stat.rpd_stat_k9Id
      );
      this.lst_stats.splice(index, 1);
    },
    edit(stat) {
      this.$emit("edit", stat);
    },
    go_report() {
      var ids = "";
      var arr_ids = [];
      for (let index = 0; index < this.lst_stats.length; index++) {
        const stat = this.lst_stats[index];
        arr_ids.push(stat.rpd_stat_k9Id);
      }
      ids = arr_ids.join("|");
      if (this.report_type == "Print") {
        //  this.swall_it("Sorry", "Print not yet availble.", "Warning");
        window.open("/printk9?ids=" + ids);
      }
      //'Team Sum'
      if (this.report_type == "Team Sum") {
        //     this.mrbreakpoint("asdf");
        window.open(
          "/printk9/teamsum/?&ids=" +
            ids +
            "&email=" +
            this.$store.state.user.email
        );
      }
      //  'TSEP Form'
      if (this.report_type == "TSEP Form") {
        this.$router.push("/tsep_form");
      }
      //pie % contact
      if (this.report_type == "Pie: Contact %") {
        this.$router.push("/piechart");
      }
      //Pie: Stop Type %
      if (this.report_type == "Pie: Stop Type %") {
        this.$router.push("/pie_stop_type");
      }
      if (this.report_type == "Line: Count by Weeks") {
        this.$router.push("/line_cnt_by_weeks");
      }
      if (this.report_type == "Print by Week") {
        window.open("/print/byweek?frm_email=" + this.$store.state.user.email);
      }

      if (this.report_type == "Print by Month") {
        window.open("/print/bymonth?frm_email=" + this.$store.state.user.email);
      }

      if (this.report_type == "Download CSV") {
        //     this.mrbreakpoint("asdf");
        window.open(
          "/mvc_download_csv_rpd_k9/rpd_data/?&ids=" +
            ids +
            "&email=" +
            this.$store.state.user.email
        );
      }
      if (this.report_type == "Map") {
        this.update_map = new Date();
        this.map_dialog_visible = true;
      }

      return true;
    },
    // downloadFile(filePath) {
    //   var link = document.createElement("a");
    //   link.href = filePath;
    //   link.download = filePath.substr(filePath.lastIndexOf("/") + 1);
    //   link.click();
    // },
    init() {
      setTimeout(() => {
        this.show_loader(false);
      }, 200);
    },
  },
  mounted() {
    this.show_loader(true);
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
